/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from "relay-runtime";
import { FragmentRefs } from "relay-runtime";
export type ScooterQuickEstimatesForm_viewer = {
    readonly currentUser: {
        readonly fullName: string;
    } | null;
    readonly " $refType": "ScooterQuickEstimatesForm_viewer";
};
export type ScooterQuickEstimatesForm_viewer$data = ScooterQuickEstimatesForm_viewer;
export type ScooterQuickEstimatesForm_viewer$key = {
    readonly " $data"?: ScooterQuickEstimatesForm_viewer$data;
    readonly " $fragmentRefs": FragmentRefs<"ScooterQuickEstimatesForm_viewer">;
};



const node: ReaderFragment = {
  "kind": "Fragment",
  "name": "ScooterQuickEstimatesForm_viewer",
  "type": "Viewer",
  "metadata": null,
  "argumentDefinitions": [],
  "selections": [
    {
      "kind": "LinkedField",
      "alias": null,
      "name": "currentUser",
      "storageKey": null,
      "args": null,
      "concreteType": "User",
      "plural": false,
      "selections": [
        {
          "kind": "ScalarField",
          "alias": null,
          "name": "fullName",
          "args": null,
          "storageKey": null
        }
      ]
    }
  ]
};
(node as any).hash = '8e7073695e5e675989b7709c6a8d45f5';
export default node;
